import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from 'vuex-persist';
import user from "./modules/user";
import global from "./modules/global";
import customer from "./modules/customer";
import rep from "./modules/rep";
import exportFeature from "./modules/export";

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: "sales_map"
})

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user, 
    global,
    customer,
    rep,
    exportFeature
  },
  plugins: [vuexLocal.plugin]
});
